import { useQuery } from "@tanstack/react-query";

import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import type { LinkedInProfile } from "common/types";

import type { BlacklistType, Company } from "../types";

async function getBlacklistRequest(workspaceId: string, type: BlacklistType) {
  const data = await get(
    `workspaces/${workspaceId}/${type === "companies" ? "blacklist-companies" : "blacklist"}`,
  );
  if (type === "companies") {
    return data.companies;
  }
  return data.profiles;
}
export default function useBlackList<T extends BlacklistType>(type: T) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { blacklistKeys } = getQueryKeys(workspaceId);

  const {
    isLoading: isLoadingBlacklist,
    data: blacklist,
    isError: isBlacklistError,
    refetch: refetchBlacklist,
  } = useQuery<(T extends "companies" ? Company : LinkedInProfile)[]>({
    queryKey: blacklistKeys.list(type),
    queryFn: () => getBlacklistRequest(workspaceId, type),
  });

  return {
    blacklist,
    refetchBlacklist,
    isLoadingBlacklist,
    isBlacklistError,
  };
}
